<template>
  <div>
    <filter-data
      with_client_portfolios
      with_envelope_number
      with_text_search
      text_search_label="Pesquisar"
      :months_before="3"
      :months_after="0"
      :initial_date_start="filterInitialStart"
      :initial_date_end="filterInitialEnd"
      min_limit_date_start="2020-01-01"
      :limit_date_start="filterMaxDate"
      :max_limit_date_end="filterMaxDate"
      @doneFilter="handleDoneFilter"
    />

    <checks-table
      :items="allChecks"
      :loading="loading"
      :headers="headers"
      :table-search="tableSearch"
      @doneUpdate="handleDoneUpdate"
      @doneReturned="handleDoneReturned"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FilterData from '@/components/shared/FilterData.vue'

export default {
  name: 'CompletedChecks',
  components: {
    ChecksTable: () => import('./shared/ChecksTable'),
    FilterData,
  },
  data() {
    return {
      headers: [
        { text: 'Pago em', value: 'attributes.payed_at', align: 'center' },
        { text: 'Módulo', value: 'attributes.place_name' },
        { text: 'Cliente', value: 'attributes.client_name', align: 'center' },
        { text: 'Valor (R$)', value: 'attributes.value', align: 'center' },
        { text: 'Bom para', value: 'attributes.good_to', align: 'center' },
        { text: 'Num. Cheque', value: 'attributes.check_number', align: 'center' },
        { text: 'Nominal', value: 'attributes.nominal', align: 'center' },
        { text: 'Envelope', value: 'attributes.envelope_name', align: 'center' },
        { text: 'Confirmado por', value: 'attributes.confirmed_by', align: 'center' },
        { text: 'Detalhes', value: 'attributes.details', align: 'center' }
      ],
      loading: false,
      local_filter: {},
    }
  },
  computed: {
    filterInitialStart() {
      return this.$moment().add(-3, 'months').format('YYYY-MM-DD')
    },
    filterInitialEnd() {
      return this.$moment().format('YYYY-MM-DD')
    },
    filterMaxDate() {
      return this.$moment().format('YYYY-MM-DD')
    },
    tableSearch() {
      return (this.local_filter && this.local_filter.query) ? String(this.local_filter.query) : ''
    },
    ...mapState({
      allChecks: state => state.Check.allChecks,
    }),
  },
  methods: {
    handleDoneFilter(e) {
      this.local_filter = { ...e }
      this.getChecks()
    },
    handleDoneUpdate() {
      this.getChecks()
    },
    handleDoneReturned() {
      this.getChecks()
    },
    getChecks() {
      const filters = {
        modality_ids: [this.activeModalityId],
        status_ids: [16, 17],
        ...this.local_filter,
      }
      if (filters.start_date) {
        filters.start_date = this.$moment(filters.start_date).startOf('day').add(-3, 'hours').toISOString()
      }
      if (filters.end_date) {
        filters.end_date = this.$moment(filters.end_date).endOf('day').add(-3, 'hours').toISOString()
      }
      this.$emit('doneFilter', { ...filters })
      if (this.activeModalityId) {
        this.loading = true
        this.indexChecks(filters).finally(() => {
          this.loading = false
        })
      } else {
        this.loading = false
      }
    },
    ...mapActions({
      indexChecks: 'Check/index'
    })
  },
  watch: {
    activeModalityId() {
      this.getChecks()
    },
  }
}
</script>
